import { Box, Chip } from '@mui/material';

export interface FilterOption {
  id: string;
  label: string;
  value: string;
}

interface FilterChipsProps {
  filters: FilterOption[];
  selectedFilters: string[];
  onChange: (selectedFilters: string[]) => void;
  label?: string;
}

/**
 * Reusable filter chips component for selecting multiple filters
 */
export function FilterChips({
  filters,
  selectedFilters,
  onChange,
  label,
}: FilterChipsProps) {
  const handleToggle = (filterId: string) => {
    const isSelected = selectedFilters.includes(filterId);
    const newFilters = isSelected
      ? selectedFilters.filter((id) => id !== filterId)
      : [...selectedFilters, filterId];
    onChange(newFilters);
  };

  if (filters.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
      {label && (
        <Box component="span" sx={{ fontSize: '0.875rem', color: 'text.secondary', mr: 1 }}>
          {label}
        </Box>
      )}
      {filters.map((filter) => (
        <Chip
          key={filter.id}
          label={filter.label}
          onClick={() => handleToggle(filter.id)}
          color={selectedFilters.includes(filter.id) ? 'primary' : 'default'}
          variant={selectedFilters.includes(filter.id) ? 'filled' : 'outlined'}
          size="small"
        />
      ))}
    </Box>
  );
}
